import { render, staticRenderFns } from "./PicUploader.vue?vue&type=template&id=5f2a27fe&"
import script from "./PicUploader.vue?vue&type=script&lang=js&"
export * from "./PicUploader.vue?vue&type=script&lang=js&"
import style0 from "./PicUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports